import * as api from "../Api";

export const location_stock_received_yearly_cost = () => async (dispatch) => {
  try {
    const { data } = await api.location_stock_received_yearly_cost();
    dispatch({ type: "LOCATION_STOCK_RECEIVED_YEARLY", payload: data });
  } catch (error) {}
};
